<template>
  <BaseModal modal-content-class="rest confirm_purch">
    <div class="content">
      <h1>{{ $_translations.value.modal_purchase_via_web_title }}</h1>

      <BaseImage
        src="/static/images/store/store_confirm_sms.svg"
        alt="pin icon"
        class="top_img"
      />

      <p class="games-to-price"><span>{{ quantityText }} - {{ priceText }}</span></p>

      <p>
        {{ $_translations.value[descriptionText] }}<br>
        {{ $_translations.value.modal_purchase_via_web_description_pt2 }}
      </p>

      <BaseButton
        :disabled="submitting"
        @click:button="handlePurchase"
      >
        {{ $_translations.value.modal_purchase_via_web_button_proceed }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import { computed, ref } from 'vue';
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import useAuthStore from '@/store/modules/auth.js';
import { bundleTypeEnum } from '@/constants/bundle.js';
import { apiPurchaseBundle } from '@/services/bundle.js';
import { apiResponseTypeEnum } from '@/constants/api.js';

const emits = defineEmits(['purchase:viaWeb']);

const props = defineProps({
  bundleId: {
    type: [String, Number],
    default: null,
  },
  bundleType: {
    type: String,
    default: '',
  },
  quantityText: {
    type: String,
    default: '',
  },
  priceText: {
    type: String,
    default: '',
  },
});

const authStore = useAuthStore();

const submitting = ref(false);

const descriptionText = computed(() => {
  if (props.bundleType === bundleTypeEnum.GAMES) {
    return 'modal_purchase_via_web_description_pt1_games';
  } else if (props.bundleType === bundleTypeEnum.JOKERS) {
    return 'modal_purchase_via_web_description_pt1_jokers';
  } else {
    return '';
  }
});

const handlePurchase = async () => {
  submitting.value = true;

  const { responseEnum } = await apiPurchaseBundle({
    payload: {
      bundleId: props.bundleId,
      pin: null,
    },
  });

  if (responseEnum === apiResponseTypeEnum.OPERATION_SUCCESS) {
    await authStore.dispatchRetrieveAuthUser().catch((error) => error);

    emits('purchase:viaWeb', { status: 'success' });
  } else if (responseEnum === apiResponseTypeEnum.NO_BALANCE) {
    emits('purchase:viaWeb', { status: 'error' });
  } else {
    emits('purchase:viaWeb', { status: 'error_operator' });
  }

  submitting.value = false;
};
</script>
